var md5 = require("md5");

const i18nDict = { zh: "zh-cn", en: "en-us" };
const language = localStorage.getItem("i18nextLng") || "zh";
// const { getUserRealNameInfo } = require("../api/user");
const translate = require(`../i18n/translations/${
  i18nDict[language as string]
}.json`).util;

// 计算间隔时间
export function spacingTime(time: number | string) {
  if (typeof time === "string") {
    time = convertMs(time);
  }
  const diff = (Date.now() - time) / 1000;
  if (diff < 60) {
    return translate["刚刚"];
  } else if (diff < 60 * 60) {
    return Math.floor(diff / 60) + translate["分钟前"];
  } else if (diff < 60 * 60 * 24) {
    return Math.floor(diff / 60 / 60) + translate["小时前"];
  } else if (diff < 60 * 60 * 24 * 7) {
    return Math.floor(diff / 60 / 60 / 24) + translate["天前"];
  } else {
    return Math.floor(diff / 60 / 60 / 24 / 7) + translate["周前"];
  }
}

// 毫秒数日期格式化
export function parseTime(
  time: Date | number | string,
  cFormat?: string
): string {
  if (arguments.length === 0 || !time) {
    return "";
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  const date = new Date(time);
  const formatObj: Record<string, any> = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
    t: date.getHours() >= 12 ? translate["下午"] : translate["上午"],
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a|t)+}/g, (result, key) => {
    let value: any = formatObj[key];
    if (key === "a")
      return [
        translate["星期一"],
        translate["星期二"],
        translate["星期三"],
        translate["星期四"],
        translate["星期五"],
        translate["星期六"],
        translate["星期日"],
      ][value - 1];
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}
// 获取指定月份得天数
export function getMonthDay(year:number, month:number) {
  let days = new Date(year, month, 0).getDate()
  return days;
}

const timeType = ['none','day','week','month','cumulative'];    // 免费领取礼包时间类型
export function countdown(downTimeType = 'day') {
  let now = new Date();        // 获取当前时间
  let day = now.getDay();      // 一周第几天
  let date = now.getDate();    // 一个月的第几天
  let year = now.getFullYear(); 
  let month = now.getMonth() + 1 ;
  //当前时间戳
  let currentTime = now.getTime();
  if(downTimeType === timeType[1]){
    now.setDate(now.getDate() + 1);
  } else if(downTimeType === timeType[2]){
    now.setDate(now.getDate() + (7 - day))  // 设置d天之后的日期 
  }else if(downTimeType === timeType[3]){
    let surplusM = getMonthDay(year, month) - date;
    now.setDate(now.getDate() + surplusM)   // 设置d天之后的日期 
  }
  let MaxDate = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + " 00:00:00"
  let endDate = new Date(MaxDate);    // 日期
  let endTime = endDate.getTime();    //时间戳

  let totalTime = Math.ceil((endTime - currentTime) / 1000);
  // totalTime -= 10*60*60 + 44*60 ;  // 测试使用
   if (totalTime > 0) {
      //  console.log('currentTime', currentTime, ',endTime', endTime, ',totalTime', totalTime);
       let seconds = Math.floor(totalTime % 60); // 秒
       let minutes = Math.floor(totalTime / 60 % 60); // 分
       let hour = Math.floor(totalTime / 60 / 60 % 24); // 时
       let _day = Math.ceil(totalTime / 60 / 60 / 24); // 天
       let res;
       if([timeType[2],timeType[3]].includes(downTimeType)){
        res = _day + "d " +
        (hour >= 10 ? hour : "0" + hour) + ":" +
        (minutes >= 10 ? minutes : "0" + minutes) + ":" +
        (seconds >= 10 ? seconds : "0" + seconds) ;

       }else{
        res =   (hour >= 10 ? hour : "0" + hour) + ":" +
        (minutes >= 10 ? minutes : "0" + minutes) + ":" +
        (seconds >= 10 ? seconds : "0" + seconds) ;
       }
       
      return res;
   }else{
       return '0';
   }
}

// 时间转化成毫秒数
export function convertMs(time: string) {
  return new Date(time.replace(new RegExp("-", "gm"), "/")).getTime();
}

// 获取时间戳
export function getTimeStamp() {
  return String(
    Math.floor(Number(new Date(new Date()).getTime()) / 1000) * 1000
  );
}

// 获取缓存时间戳
export function getLocalStorageTimeStamp() {
  return localStorage.getItem("timestamp");
}

// 设置缓存时间戳
export function setLocalStorageTimeStamp() {
  const timestamp = getTimeStamp();
  localStorage.setItem("timestamp", timestamp);
}

// 毫秒转换日期
export function convertDateTime(time: number) {
  return parseTime(time);
}

// 校验登录态
export function checkIsLogin() {
  const userInfo = localStorage.getItem("userInfo") || "{}";
  const userInfoJson = JSON.parse(userInfo);
  return !isEmpty(userInfoJson) ? true : false;
}

// 复制字符串到剪切板
export function copyToClipboard(text: string) {
  // 数字没有 .length 不能执行selectText 需要转化成字符串
  const textString = text.toString();
  let copyResult = false;
  let input: HTMLInputElement | null = document.querySelector("#copy-input");
  if (!input) {
    input = document.createElement("input");
    input.id = "copy-input";
    input.readOnly = true; // 防止ios聚焦触发键盘事件
    input.style.position = "absolute";
    input.style.left = "-1000px";
    input.style.zIndex = "-1000";
    document.body.appendChild(input);
  }
  input.value = textString;
  // ios必须先选中文字且不支持 input.select()
  selectText(input, 0, textString.length);
  if (typeof document.execCommand === "function") {
    document.execCommand("copy");
    copyResult = true;
  } else {
    copyResult = false;
  }
  input.blur();
  document.body.removeChild(input);
  return copyResult;

  // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
  // 选择文本。createTextRange(setSelectionRange)是input方法
  function selectText(textbox: any, startIndex: any, stopIndex: any) {
    if (textbox.createTextRange) {
      // ie
      const range = textbox.createTextRange();
      range.collapse(true);
      range.moveStart("character", startIndex); // 起始光标
      range.moveEnd("character", stopIndex - startIndex); // 结束光标
      range.select(); // 不兼容苹果
    } else {
      // firefox/chrome
      textbox.setSelectionRange(startIndex, stopIndex);
      textbox.focus();
    }
  }
}

// 获取缩略图及是否为gif图
export function getThumbnailImage(
  url: string,
  target: "list" | "detail" = "list"
) {
  const thumbnailInfo = {
    url,
    isGif: false,
  };
  // 根据域名判断下图片是不是社区上传的，如果是，则提供缩略图
  const matchObj = url.match(/^http(s)?:\/\/(.*?)\//);
  // 列表中缩略图需强制转换为jpg格式
  const suffix = url.split(".").pop()?.toLocaleLowerCase();
  if (matchObj && matchObj[2] === window.GLOBALCONFIG.APIHOST.imageHost) {
    const thumbnailImageParam = {
      list: "?x-oss-process=image/resize,s_380/quality,q_60/auto-orient,0/interlace,1/format,jpg",
      detail:
        "?x-oss-process=image/resize,s_600/quality,q_60/auto-orient,0/interlace,1/format,",
    };
    thumbnailInfo.url = `${url}${thumbnailImageParam[target]}${
      target === "detail" ? suffix : ""
    }`;
    thumbnailInfo.isGif = suffix === "gif";
  }
  return thumbnailInfo;
}

// 获取当前是否是手机端登录
export function getIsPhone() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPad|iPod|iPhone|ios|Android|Mobile|IEMobile|BlackBerry|JUC|Fennec|wOSBrowser|WebOS|MQQBrowser|BrowserNG|Symbian|Windows Phone)/i
    )
  ) {
    return true;
  }
  return false;
}

// 判断变量是否为空
export function isEmpty(s: String | Object | Array<string> | undefined | null) {
  if (s instanceof String && s.length === 0) {
    return true;
  }
  if (s instanceof Object && JSON.stringify(s) === "{}") {
    return true;
  }
  if (Array.isArray(s) && !s.length) {
    return true;
  }
  if (typeof s === "undefined") {
    return true;
  }
  if ( s === null){
    return true
  }

  return false;
}

// 签名
export function setSign(data: Record<string, any>) {
  const key = "x9cu7qt6bqm6yk09e40hna248vs940l0";
  const timestamp = localStorage.getItem("timestamp");
  const sign = md5(JSON.stringify(data) + "&" + timestamp + "&" + key);
  // console.log("签名明文：", JSON.stringify(data) + "&" + timestamp + "&" + key);
  // console.log("签名密文：", sign);
  return sign;
}

// 设置访问GSC请求得头部信息
export function setGscHeaders(headers: Record<string, any>) {
  const currentProduct = localStorage.getItem("currentProduct") || "";
  // console.log("当前产品简称：", currentProduct);
  const productInfo = JSON.parse(localStorage.getItem("productInfo") || "{}");
  // 获取当前产品的ID和地域，放入请求头中
  // console.log("当前产品信息：", productInfo);

  headers["request-productid"] = productInfo[currentProduct]?.productId || "";
  headers["request-locale"] = productInfo[currentProduct]?.localeId || "";

  return headers;
}

// 处理手机号码，中间四位加密
export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) {
    return "";
  }
  if (phoneNumber.length != 11) {
    return "****";
  }
  return phoneNumber.slice(0, 3) + "****" + phoneNumber.slice(7);
};

// 处理商品金额,分-》元
export const formatGoodsCost = (cost: number) => {
  if (cost > 0) {
    return parseFloat((cost / 100).toFixed(2));
  }
  return cost;
};

/**
 * 检查用户名
 * @param {*} account
 */
export const checkAccount = (account: string) => {
  console.debug("待检查的用户名为", account);
  let reg = /^[A-Za-z\d_@.]{5,100}$/;
  return reg.test(account);
};
